import { getSvgUrlWithDefaults } from 'JS/shared/providers';

export default async function applyImageRecolor(imageEl) {
  const { url, recolorDefaults } = await getSvgUrlWithDefaults({
    provider: imageEl.image.provider,
    contentType: imageEl.image.contentType,
    assetId: imageEl.image.assetId ?? imageEl.image.imageId,
    recolor: imageEl.image.recolor
  });
  imageEl._imageUrl = url;
  imageEl._recolorDefaults = recolorDefaults;
  imageEl.recolorAvailable = Object.keys(recolorDefaults).length > 0;
}
